export var ACTION;
(function (ACTION) {
    ACTION["REPAYMENT"] = "REPAYMENT";
    ACTION["GO_BACK"] = "GO_BACK";
    ACTION["OPEN_TAB"] = "OPEN_TAB";
    ACTION["GO_TO_AUTOPAY"] = "GO_TO_AUTOPAY";
    ACTION["POLL_AGREEMENT_STATUS"] = "POLL_AGREEMENT_STATUS";
    ACTION["GO_TO_LOAN_AGREEMENT"] = "GO_TO_LOAN_AGREEMENT";
    ACTION["FAILED_VERIFICATION"] = "FAILED_VERIFICATION";
    ACTION["SUCCESS_VERIFICATION"] = "SUCCESS_VERIFICATION";
    ACTION["INIT_DOCS"] = "INIT_DOCS";
    ACTION["AGREEMENT_DEEP_CALL"] = "AGREEMENT_DEEP_CALL";
    ACTION["MOVE_TO_NEXT_STEP"] = "MOVE_TO_NEXT_STEP";
    ACTION["RETRY_AGREEMENT_HIDE_POPUP"] = "RETRY_AGREEMENT_HIDE_POPUP";
    ACTION["NAV_CONTACT_US"] = "NAV_CONTACT_US";
    ACTION["ON_LOAD"] = "ON_LOAD";
    ACTION["EMPTY_ACTION"] = "EMPTY_ACTION";
})(ACTION || (ACTION = {}));
